import { z } from 'zod';

import type { ModelInstanceSpec } from '../../../capabilities/maas-model-storage/modelInstanceTypes';
import type { NicPricingByDeviceType } from '../../../components/nicPricing/utils';

/** 模型实例交付规格：与后端 ModelInstanceSpec 对齐 */
export type MiSpec = Omit<ModelInstanceSpec, 'network'> & {
  network?: ModelInstanceSpec['network'] & {
    /** SKU / 下单询价字段，仅在 headless 内部流转，不进入 ModelInstance API。 */
    nicPricing?: NicPricingByDeviceType;
  };
};

export const MiSpecSchema = z.custom<MiSpec>((val) => val != null && typeof val === 'object');

export type MiApiPayload = ModelInstanceSpec & Record<string, unknown>;
